import { useContext, useMemo } from "react";
import { rfqPendingItemType } from "../../queries/types";
import { StyledDatagrid } from "../../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../../styles/Variables";
import { TableHeaderProps } from "../../../../../../../utils/types";
import useAssetTableJson from "../../../../../../../json/useAssetTableJson";
import { GridAlignment, GridColDef } from "@mui/x-data-grid-pro";
import { Title } from "../../../../../../../stories/Title/Title";
import { AppContext } from "../statesProvider/materialContext";
import { rfqStatesType } from "../statesProvider/materialReducer";
import Close from "../../../../../../../images/Close.svg";
import { Button } from "../../../../../../../stories/Button/Button";
import useLabels from "../../../../../../../customHooks/useLabels";

interface Props {
  itemOptions: rfqPendingItemType[];
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  handleItemSelect: (newValue: rfqPendingItemType | null) => void;
}
const ItemsModal = ({ itemOptions, setModalFlag, handleItemSelect }: Props) => {
  const { Rfqs } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);
  const dynamicHeaders: TableHeaderProps[] = Rfqs.ItemListModal.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      cellClassName: header.cellClassName,
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];
  const rowData = useMemo(() => {
    return itemOptions.map((node, index) => {
      const taxvalue = (node.tax / 100) * node.taxable;

      return {
        id: index + 1,
        udfItemDesc: node.udfItemDesc,
        item_desc: node.item.code.length
          ? `${node.item.desc}`
          : `${node.item.desc} (${node.item.code})`,
        uom: node.uom,
        presentStk: node.presentStk,
        approxRate: node.approxRate,
        acceptQty: node.acceptQty,
        taxable: node.taxable,
        tax: node.tax,
        taxvalue: taxvalue,
        netvalue: node.taxable + taxvalue,
        itm: node,
      };
    });
  }, [itemOptions]);
const {itemLabel}=useLabels();
  return (
    <div className="items">
      <div className="items__title">
        <Title>{itemLabel} for {state.mrf ? state.mrf.node.mrfNo : null}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="items__tableblock">
        <StyledDatagrid
          columns={columns}
          rows={rowData}
          rowHeight={TABLE_ROW_HEIGHT}
          onCellClick={(params) => {
            if (params.field === "item_desc") {
              setModalFlag(false);
              handleItemSelect(params.row.itm);
            }
          }}
          disableRowSelectionOnClick
          hideFooter
        />
      </div>
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
    </div>
  );
};

export default ItemsModal;
